<section role="region" aria-labelledby="institution-create-heading">
	<h2 id="institution-create-heading" lvrPadding [padHorizontal]="32" [padVertical]="0">
		{{ 'institution.create.title' | transloco }}
	</h2>
	<form [formGroup]="form" class="form-container" lvrAutoSave="institution" [entityId]="draftId" [autoLoad]="false">
		<h3 id="institution-base-heading" lvrPadding [padVertical]="8">{{ 'institution.create.base_info' | transloco }}</h3>
		<section class="form-grid" aria-labelledby="institution-base-heading">
			<!-- Name Field -->
			<lvr-field [label]="'institution.create.name' | transloco | appendAsterisk">
				@let nameCtrl = form.get('name');
				<mat-form-field lvrInput [lvrError]="hasError(nameCtrl, 'pattern', 'required')">
					<input matInput formControlName="name" placeholder="Stadt Köln" [errorStateMatcher]="matcher" />
					@if (hasError(nameCtrl, 'pattern')) {
						<mat-error>{{ 'base.form.error.branch_name_invalid' | transloco }}</mat-error>
					}
					@if (hasError(nameCtrl, 'required')) {
						<mat-error>{{ 'institution.create.errors.name_required' | transloco }}</mat-error>
					}
				</mat-form-field>
			</lvr-field>
			<!-- Address Field -->
			<lvr-address-completion
				formControlName="address"
				class="address-completion"
				[checkForDuplicatedAddress]="checkDuplicatedAddress()"
				[duplicatedAddressCheckerAsync]="duplicatedAddressCheckAsync"
			></lvr-address-completion>
			<!-- Employment Required / Not Required -->
			<lvr-field>
				<mat-radio-group
					formControlName="employmentRequired"
					[attr.aria-label]="'institution.create.employment_required' | transloco"
				>
					<mat-radio-button [value]="true">{{
						'institution.create.employment_required_option_yes' | transloco
					}}</mat-radio-button>
					<mat-radio-button [value]="false">{{
						'institution.create.employment_required_option_no' | transloco
					}}</mat-radio-button>
				</mat-radio-group>
			</lvr-field>
			<!-- URL Field -->
			<lvr-field [label]="'institution.create.url' | transloco">
				<mat-form-field lvrInput>
					<input matInput formControlName="url" placeholder="https://www.example.com" />
				</mat-form-field>
			</lvr-field>
		</section>

		<!-- Contact Point Field -->
		@for (item of communicationWayCountArrayKeys(); track $index) {
			<section class="form-grid">
				<h3 lvrPadding class="additional-communication-heading" [padVertical]="0" [padHorizontal]="8">
					@if (communicationWayCount() > 1) {
						<span>{{ 'base.field.contact_point.title' | transloco }}</span>
						<button matIconButton class="btn btn-tertiary" (click)="removeCommunicationWay($index)">
							<mat-icon class="material-symbols-outlined" aria-hidden="true">delete</mat-icon>
						</button>
					} @else {
						<span>{{ 'base.field.contact_point.title' | transloco }}</span>
					}
				</h3>
				<lvr-contact-point
					[contactPointCategories]="contactPointCategories()"
					class="address-completion"
					(values)="updateValues($event, $index)"
				></lvr-contact-point>
			</section>
		}
		<section class="form-grid">
			<!-- Add additional button -->
			@if (communicationWayCount() < 5) {
				<lvr-button
					variant="primary"
					[label]="'base.field.contact_point.title' | transloco"
					[ariaLabel]="'base.field.contact_point.add_communication' | transloco"
					[type]="'button'"
					(clicked)="addCommunicationWay()"
					icon="add"
				></lvr-button>
			}
		</section>

		<lvr-default-actions
			[disableSave]="form.invalid || !canCreateInstitutionsPermission()"
			[showLoading]="saving()"
			(save)="save()"
			(cancelSave)="cancel()"
		>
			<lvr-restore-actions entityType="institution" [entityId]="draftId"></lvr-restore-actions>
		</lvr-default-actions>
	</form>
</section>
